import { computed } from "vue";
export function useChatTheme(clientInfo) {
  const primaryColor = computed(() => {
    return clientInfo.value?.chatConfiguration?.branding?.color?.hex || "#6366f1";
  });
  const cssVariables = computed(() => ({
    "--ce-chat-color-primary": primaryColor.value,
    "--ce-chat-color-gradient-active-start": "#1D62EE",
    "--ce-chat-color-gradient-active-end": "#7A14EF",
    "--ce-chat-color-gray-200": "#D3D3D3",
    "--ce-chat-color-blue-50": "#F3F6FC",
    "--ce-chat-color-grey-950": "#2D2D2D",
    "--ce-chat-color-border-radius-md": "8px",
    "--ce-chat-color-border-radius-none": "0"
  }));
  return {
    primaryColor,
    cssVariables
  };
}
